import { RiTestTubeLine } from "@onemind-services-llc/react-icons-ng/ri";
import { AiOutlineSetting } from "@onemind-services-llc/react-icons-ng/ai";
import {
  MdOutlineCloudDone,
  MdOutlineIntegrationInstructions,
} from "@onemind-services-llc/react-icons-ng/md";

export const PERFORMANCE_OEM_LABS_CONSTANTS = {
  title: "Importance of Performance and OEM Test Labs",
  desc: "Engaging with Performance and OEM Test Labs ensures product quality, regulatory compliance, and market readiness through rigorous testing and validation.",
  list: [
    {
      icon: RiTestTubeLine,
      title: "Quality Assurance",
      content:
        "Ensures products meet or exceed industry and manufacturer standards, enhancing reliability and customer satisfaction.",
    },
    {
      icon: AiOutlineSetting,
      title: "Risk Mitigation",
      content:
        "Identifies potential issues before products reach the market, reducing the likelihood of failures and associated costs.",
    },
    {
      icon: MdOutlineCloudDone,
      title: "Regulatory Compliance",
      content:
        "Assists in meeting legal and industry-specific requirements, facilitating smoother market entry.",
    },
    {
      icon: MdOutlineIntegrationInstructions,
      title: "Competitive Advantage",
      content:
        "Demonstrates a commitment to quality and performance, distinguishing products in a crowded marketplace.",
    },
  ],
};
